<div class="mail-container">
    <div class="mail-header">
        <div class="mail-header-row">
            <p>
                <b>Sujet:</b>
                {{ emailDocument.subject }}
            </p>
            <p class="date-header">
                <b>Date:</b>
                {{ emailDocument.originalDate | AvmDateAndTime }}
            </p>
        </div>
        <div class="mail-header-row">
            <p>
                <b>De:</b>
                {{ emailDocument.from?.replace(addressesDelimiterRegex, '; ') }}
            </p>
        </div>
        <div class="mail-header-row">
            <p>
                <b>A:</b>
                {{ emailDocument.to?.replace(addressesDelimiterRegex, '; ') }}
            </p>
        </div>
    </div>
    @if (displayPreview === true) {
        <iframe class="preview-iframe" [srcdoc]="emailBody | byPassSecurity"></iframe>
    }
</div>
